export default __webpack_public_path__ + "static/media/Krist.55eca93f.jpg";